import type { ConfigUrls } from 'hb-react/frontoffice/apps/Forum/types';
import { getForumHeaderControls } from 'hb-react/frontoffice/apps/Forum/utils';
import { useTopicContext } from 'hb-react/frontoffice/contexts/TopicContext';
import getPageCustomizableHeaderProps from 'hb-react/shared/apps/PageCustomizables/utils/getPageCustomizableHeaderProps';
import type { AppPageConfig } from 'hb-react/types';

import { useCanCreateDiscussion } from './useCanCreateDiscussion';

interface HeaderProps {
  appPageConfig: AppPageConfig;
  configUrls: ConfigUrls;
}

export const useGetForumHeaderProps = ({
  appPageConfig,
  configUrls,
}: HeaderProps) => {
  const canCreateDiscussion = useCanCreateDiscussion();
  const { topicId } = useTopicContext();

  const { controls } = getForumHeaderControls({
    appPageConfig,
    canCreateDiscussion,
    configUrls,
    topicId,
  });

  return getPageCustomizableHeaderProps({
    appPageConfig,
    controls,
    useOldForm: false,
  });
};
